import { createDynamicSlice } from ".";
import { fetchInternalErrorRcaThunk } from "../thunks/internalErrorRcaThunk";

export const internalErrorRcaSlice = createDynamicSlice({
  name: "internalErrorRca",
  thunk: fetchInternalErrorRcaThunk,
  listMode: true,
  resetActionName: "resetInternalErrorRca",
});

export const internalErrorRcaReducer = internalErrorRcaSlice.reducer;
export const { resetInternalErrorRca } = internalErrorRcaSlice.actions;
